import React from "react";
function Header() {
  return (
    <div>
      <h1>Can't pick today's mood?</h1>
    </div>
  );
}

export default Header;
